import React from "react";
import PropTypes from "prop-types";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { NumericInput } from "@/components/inputs";

/**
 * ConstructionFields — conditional fields shown when loan type is Construction.
 *
 * Renders Land Cost, Total Estimated Soft Costs, Total Estimated Hard Costs,
 * Additional Investor Equity, and a computed Total Project Cost.
 */
export default function ConstructionFields({ scope }) {
  const { control, formState: { errors } } = useFormContext();
  const stepErrors = errors?.[scope];

  const [landCost, softCost, hardCost] = useWatch({
    control,
    name: [
      `${scope}.landCost`,
      `${scope}.totalSoftCostSpent`,
      `${scope}.totalHardCostSpent`,
    ],
  });

  const totalProjectCost =
    parseFloat(landCost || 0) +
    parseFloat(softCost || 0) +
    parseFloat(hardCost || 0);

  return (
    <>
      <div className="col-span-2 sm:col-span-1">
        <Controller
          name={`${scope}.landCost`}
          control={control}
          render={({ field }) => (
            <NumericInput
              placeholder="Land Cost or Property Price"
              value={field.value}
              onChange={field.onChange}
              format="c0"
              currency="USD"
              min={0}
              error={stepErrors?.landCost?.message}
            />
          )}
        />
      </div>
      <div className="col-span-2 sm:col-span-1">
        <Controller
          name={`${scope}.totalSoftCostSpent`}
          control={control}
          render={({ field }) => (
            <NumericInput
              placeholder="Total Estimated Soft Costs"
              value={field.value}
              onChange={field.onChange}
              format="c0"
              currency="USD"
              min={0}
              error={stepErrors?.totalSoftCostSpent?.message}
            />
          )}
        />
      </div>
      <div className="col-span-2 sm:col-span-1">
        <Controller
          name={`${scope}.totalHardCostSpent`}
          control={control}
          render={({ field }) => (
            <NumericInput
              placeholder="Total Estimated Hard Costs"
              value={field.value}
              onChange={field.onChange}
              format="c0"
              currency="USD"
              min={0}
              error={stepErrors?.totalHardCostSpent?.message}
            />
          )}
        />
      </div>
      <div className="col-span-2 sm:col-span-1">
        <Controller
          name={`${scope}.additionalInvestorEquity`}
          control={control}
          render={({ field }) => (
            <NumericInput
              placeholder="Additional Investor Equity"
              value={field.value}
              onChange={field.onChange}
              format="c0"
              currency="USD"
              min={0}
              error={stepErrors?.additionalInvestorEquity?.message}
            />
          )}
        />
      </div>
      <div className="col-span-2 sm:col-span-1">
        <NumericInput
          placeholder="Total Project Cost"
          value={totalProjectCost}
          disabled
          format="c0"
          currency="USD"
        />
      </div>
    </>
  );
}

ConstructionFields.propTypes = {
  scope: PropTypes.string.isRequired,
};

